import entries from 'lodash/entries';
import flatMap from 'lodash/flatMap';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import { requiredArg } from './args';

export const cloneWithFilter = (
  value,
  filterFn = () => true,
  parentPath = []
) => {
  if (isArray(value) && value.length && value.every(_ => isPlainObject(_))) {
    return flatMap(value, (_, index) => {
      const path = [...parentPath, index];
      return filterFn(path, _) ? cloneWithFilter(_, filterFn, path) : [];
    });
  }

  if (isPlainObject(value))
    return entries(value).reduce((acc, [key, _]) => {
      const path = [...parentPath, key];
      return filterFn(path, _)
        ? { ...acc, [key]: cloneWithFilter(_, filterFn, path) }
        : acc;
    }, {});

  return value;
};

export const pruneUnwantedProperties = (object, propertyMap) =>
  cloneWithFilter(
    object,
    (path, value) =>
      get(propertyMap, path, false) &&
      value !== '' &&
      !(isArray(value) && value.length === 0)
  );

export const pruneUnwantedPropertiesForPage = ({
  pageName = requiredArg('pageName'),
  formValues = requiredArg('formValues'),
  getFormStructure = requiredArg('getFormStructure'),
}) => {
  const prunedFormValues = pruneUnwantedProperties(
    get(formValues, pageName, {}),
    get(getFormStructure(), pageName, {})
  );

  return {
    ...formValues,
    [pageName]: prunedFormValues,
  };
};
